module.exports = __webpack_public_path__ + "img/youtube.030c0b2f.svg";